
<template lang="pug">
q-modal(
  v-model="visible"
  minimized
  no-backdrop-dismiss
)
  .shifts-memo.q-ma-md
    .q-title.q-mb-sm(v-if="params.title") {{params.title}}

    q-field.shifts-memo-field.q-mb-md(:count="1024")
      q-input(
        ref="focus"
        type="textarea"
        v-model.trim="text"
        float-label="メモ"
        maxlength="1024"
      )

    //- 新規モード
    .flex.justify-end
      q-btn.q-mx-sm(
        color="primary"
        flat
        :disable="text == original"
        @click="confirm"
      ) 決定

      q-btn.q-mx-sm(
        color="dark"
        flat
        v-close-overlay
      ) キャンセル
</template>

<script>
export default {
  data() {
    return {
      visible:  false,

      text: '',
      original: '',
      params: {},
    }
  },

  methods: {
    show(text, params) {
      this.text = text
      this.original = text
      this.params = params

      this.visible = true

      setTimeout(() => {this.$refs.focus.focus()}, 0)
    },

    hide() {
      this.visible = false
    },

    confirm() {
      this.$emit('confirm', this.text)
    },
  },
}
</script>

<style lang="sass">
.shifts-memo
  width: 70vw
</style>
